import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { observer, useAsObservableSource } from 'mobx-react-lite';
import {
    TrashIconWrapper,
    ActiveLabel,
    DatesContainer,
    DateWrapper,
    DateTitle,
    DateValue,
} from 'src/main/cms/HomePageCarousel/PromoCarouselList/PromoCarouselListItem.styles';
import { BannerTitle, BannerImage } from './SingleBanner.style';
import { Checkbox } from 'src/components/Checkbox/Checkbox';
import moment from 'moment';
import { CasinoBannersDataState } from 'src/AppState/CmsState/CasinoBannersDataState/CasinoBannersData.state';
import { SingleBannerState } from './SingleBanner.state';
import { CasinoBannerType } from 'src/domains/casino/models/models';
import { ListItem, ActionsWrapper, ButtonsWrapper } from 'src/domains/layouts/shared/cms/list/List.style';
import { MoveUpDown } from 'src/domains/layouts/shared/moreActions/MoveUpDown';
import { Button } from 'src/domains/layouts/shared/buttons/Button';

interface PropsType {
    banner: CasinoBannerType;
    casinoBannersState: CasinoBannersDataState;
}

export const SingleBanner = observer((propsInner: PropsType) => {
    const props = useAsObservableSource(propsInner);
    const [state] = React.useState(() => new SingleBannerState(props));
    const { title, published, image_mobile, image_tablet, image_desktop, date_start, date_end } = props.banner;
    const startDate = moment(date_start).format('DD-MM-YYYY hh:mm:ss');
    const endDate = moment(date_end).format('DD-MM-YYYY hh:mm:ss');

    return (
        <ListItem
            boxHeight='210px'
            direction='column'
            data-test={`casino-banner-id-${props.banner.id}`}
        >
            <BannerTitle data-test='casino-banner-title'>{title}</BannerTitle>

            <picture>
                <source
                    media='(min-width: 968px)'
                    srcSet={image_desktop}
                />
                <source
                    media='(min-width: 615px)'
                    srcSet={image_tablet}
                />
                <BannerImage
                    src={image_mobile}
                    alt={title}
                />
            </picture>

            <DatesContainer>
                <DateWrapper isStart>
                    <DateTitle>Scheduled start</DateTitle>
                    <DateValue>{startDate}</DateValue>
                </DateWrapper>
                <DateWrapper>
                    <DateTitle>Scheduled finish</DateTitle>
                    <DateValue>{endDate}</DateValue>
                </DateWrapper>
            </DatesContainer>

            <Checkbox
                labelSide='right'
                onChange={state.setPublished}
                isChecked={published}
                isDisabled={false}
            >
                <ActiveLabel>Published</ActiveLabel>
            </Checkbox>

            <ButtonsWrapper>
                <MoveUpDown
                    moveItemUp={state.moveUp}
                    moveItemDown={state.moveDown}
                />
                <ActionsWrapper>
                    <Button
                        version='secondary'
                        size='small'
                        onClick={state.editBanner}
                        data-test='casino-banner-edit-button'
                    >
                        Edit
                    </Button>
                    <TrashIconWrapper onClick={state.deleteBanner} />
                </ActionsWrapper>
            </ButtonsWrapper>
        </ListItem>
    );
});
